import React from "react";

const Declaration = () => {
  return (
    <table>
      <tbody>
        <tr>
          <td>
            <b>H) DECLARATION AND AUTHORISATION</b>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              I/We hereby declare that to the best knowledge and belief the statements and answers
              given in this health declaration are true, complete and that I/We have not withheld
              any material facts, that is, facts likely to influence the assessment and acceptance
              of this application. I/We understand that any misstatement of fact, whether by
              commission or omission may be grounds for the Company in its absolute and sole
              discretion to decline to pay any benefit for myself and/or my Dependant(s) which may
              otherwise have been payable. I/We agree that this application, together with any
              additional statements signed by myself and/or my Dependant(s) which shall be deemed to
              be part of this declaration, shall be the basis of the contract of the insurance.
            </p>
            <p>
              I/We understand that my application will be subject to acceptance by the Company, and
              that I and/or my Dependant(s) will not be insured under any of the insurance plan(s)
              for which I and/or my Dependant(s) are subject to acceptance until the Company advises
              the Policyholder the terms and conditions on accepting insurance on myself and/or
              Dependant(s), and that the Company reserves the right to decline insurance or impose
              special terms and conditions.
            </p>
            <p>I/We understand that:</p>
            <ol type="i">
              <li>
                If my application for myself and/or my Dependant(s)’ insurance under any of the
                above plan(s) is accepted, myself and/or my Dependant(s)’ insurance under the plan
                shall terminate if the Policyholder does not renew the plan upon expiry of any
                period of insurance, or cancel the plan, or if I and/or my Dependant(s) attain the
                age at which I and/or my Dependant(s)’ insurance terminates as specified in the
                terms and conditions of the insurance plan, and
              </li>
              <li>
                These plan(s) are yearly renewable and that the terms and conditions of the
                insurance plan(s) I and/or Dependant(s) are insured under, including the premium
                payable, at any renewal of the plan(s), may change upon agreement between the
                Policyholder and the Company.
              </li>
            </ol>
            <p>
              I/We hereby authorize any hospital, medical practitioner, clinic or other medical
              related facility, insurance company or other organizations or persons to release to
              you any information concerning my/our medical condition or history or knowledge of me
              and/or my Dependant(s) to the Company for risk assessment of my Group Insurance
              Application. I/We further consent to the Company in releasing any information declared
              in my and/or my Dependant(s)’ Personal Health Declaration Form / Personal Statement
              and/or information revealed in my and/or my Dependant(s)’ questionnaires, medical
              reports and laboratory reports to my employer or the administrator and/or the
              appointed insurance intermediary servicing this Group Insurance Policy. A photocopy of
              this authorisation shall be as effective and valid as the original.
            </p>
            <p className="warning">
              <b>WARNING</b>: If a material fact is not disclosed in this proposal, any policy
              issued may not be valid. If you are in doubt as to whether a fact is material, you are
              advised to disclose it. This includes any information that you may have provided to
              the insurance advisor/agent but was not included in the proposal. Please check to
              ensure that you are fully satisfied with the information declared in this proposal.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Declaration;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Declaration.jsx